import { Box, Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ExpandableImage from '../../Shared/ExpandableImage';
import { theme } from '../../../../../legacy/style/theme';
import Measure from '../../Shared/Measure';
import { useAppSelector } from '../../../../../../types';
import { sessionByIdQuery } from '../../../../../../core/sessions/queries';
import { ImageProperties } from '../../../../../../core/domain/map';

type Props = {
    properties: ImageProperties;
};

const Content: FC<Props> = ({ properties }) => {
    const { t } = useTranslation();
    const session = useAppSelector(sessionByIdQuery(properties.sessionId));

    return (
        <Box marginBottom=".25rem">
            <Typography
                noWrap
                sx={{
                    wordBreak: 'break-all',
                    color: theme.color.black.main,
                    fontWeight: 600,
                }}
            >
                {session?.name}
            </Typography>
            {properties.roadName && properties.roadCumul != null ? (
                <>
                    <Measure label={t('map.popup.road-name')} value={properties.roadName} />
                    <Measure
                        label={t('map.popup.cumul-start-image')}
                        value={`${t('map.popup.start')} + ${properties.roadCumul.toFixed(0)}m`}
                    />
                </>
            ) : (
                <Measure
                    label={t('map.popup.cumul-start-image')}
                    value={`${t('map.popup.start')} + ${properties.cumulStartSession.toFixed(0)}m`}
                />
            )}
            <ExpandableImage sessionId={properties.sessionId} imageIndex={properties.imageIndex} />
        </Box>
    );
};

export default Content;
